import { useEffect, useRef } from "preact/hooks"

export function SwiperSlide({ className, children }) {
    return (
        <div class={`swiper-slide ${className}`}>
            {children}
        </div>
    )
}

export function Swiper({ className, options = {}, watchChildren, gutterTotal, init, showProgressBar, children }) {
    const swiperElRef = useRef(null);
    const instanceRef = useRef(null);
    const wrapperRef = useRef(null);
    const progressBarRef = useRef(null);

    useEffect(() => {
        const width = Math.floor(wrapperRef.current?.scrollWidth) || 9999;

        if(!init || (width - 1 + gutterTotal) <= window.innerWidth) {
            swiperElRef.current.classList.add('swiper-not-initialized');
            return;
        }

        const updateProgress = (swiperInstance) => {
            const swiper = swiperInstance || instanceRef.current;
            const total = Array.isArray(children) ? children.length : 1;
            if (swiper.params.slidesPerView === "auto" || total === 0) return;
    
            const current = swiper.realIndex;
            const slidesInView = Math.round(swiper.params.slidesPerView);
            const slideIndex =
                current + slidesInView > total
                    ? current + slidesInView - total
                    : current + slidesInView;
    
            const progress = (slideIndex / total) * 100;
            if (progressBarRef.current) {
                progressBarRef.current.style.display = swiper.isLocked ? 'none' : '';
                progressBarRef.current.style.setProperty('--progress',`${Math.min(progress, 100)}%`);
            }
        }

        if(!instanceRef?.current && swiperElRef?.current && window.Swiper) {
            instanceRef.current = new window.Swiper(swiperElRef.current, options)
            swiperElRef.current.swiper = instanceRef.current;

            if(showProgressBar) {
                instanceRef.current.on("slideChangeTransitionStart", updateProgress);
                instanceRef.current.on("breakpoint", updateProgress);
                updateProgress();
            }
        }

        return () => {
            if(instanceRef.current){
                instanceRef.current.destroy(true);
                instanceRef.current = null;
                swiperElRef.current.classList.add('swiper-not-initialized')
            }
        }
    }, [])

    useEffect(() => {
        if(init && watchChildren && instanceRef.current) {
            instanceRef.current.update();
        }
    }, [ init, watchChildren, children ])

    return (
        <>
            <div
                class={`swiper ${className}`} 
                ref={swiperElRef} 
            >
                <div class="swiper-wrapper" ref={wrapperRef}>
                    {children}
                </div>
            </div>
            {(init && showProgressBar) && (
                <div class="ns-progress-bar-container" ref={progressBarRef}>
                    <div class="ns-progress-bar">
                        <div class="ns-progress-bar-fill" />
                    </div>
                </div>
            )}
        </>
    )
}
